import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useOktaAuth } from '@okta/okta-react';
import { Link } from 'react-router-dom';

import { trackPageView, initAdSense } from "../services/googleServices";

import Search from "./search";
import Beers from "./beers";

const Favourites = ({ favourites, searchQuery }) => {
  const { authState } = useOktaAuth();

  const isAuthenticated = Boolean(authState?.isAuthenticated);
  const hasOpenedCdResources = typeof window !== 'undefined' && 
    (sessionStorage.getItem('cd_resource_opened') === 'true' || 
     /(^|\.)clouddashboard\./i.test(window.location.hostname));
  const hasSearched = Boolean(searchQuery && searchQuery.trim().length > 0);

  // Unauthorised visitors or authorised visitors who opened CD resources (before search is done) see ads;
  // Once search is done on Home or Favourites, hide ads for authorised users and show Pro NFT card instead.
  // Pure PCD users never see ads.
  const shouldShowAd = !isAuthenticated || (isAuthenticated && hasOpenedCdResources && !hasSearched);
  const shouldShowNft = isAuthenticated && (!hasOpenedCdResources || hasSearched);

  const filteredFavourites = hasSearched
    ? favourites.filter(beer =>
        (beer.name && beer.name.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (beer.tagline && beer.tagline.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (beer.description && beer.description.toLowerCase().includes(searchQuery.toLowerCase()))
      )
    : favourites;

  useEffect(() => {
    trackPageView(window.location.pathname + window.location.search);
    if (shouldShowAd) {
      initAdSense();
    }
  }, [shouldShowAd]);

  return (
    <>
      <header className="justify-content-center py-2 bg-warning text-center text-white">
        <div className="container">
          <div className="row">
            <div className="col">
              <h1 className="font-weight-bold">Beer Bank | {authState?.isAuthenticated ? 'The Personalized Cloud Dashboard' : 'The Cloud Dashboard'} {process.env.REACT_APP_VERSION}</h1>
              <p>These are your favourite beers (digital and actual)</p>
            </div>
          </div>
          <Search />
          <div className="mt-2 text-center">
            <small>
              <span className="text-white-50">Missing expected favourite health cards? </span>
              <Link to="/ecosystem/SER" className="text-white text-decoration-underline font-weight-bold" style={{ textShadow: '0 1px 2px rgba(0,0,0,0.2)' }}>
                Check Synchronization Error Reporting (SER) &raquo;
              </Link>
            </small>
          </div>
        </div>
      </header>
      <Beers
        beers={filteredFavourites}
        searchQuery={searchQuery}
        isPcdUser={isAuthenticated}
        showNftCard={shouldShowNft}
        showAdCard={shouldShowAd}
      />
    </>
  );
};

// redux stuff
Favourites.propTypes = {
  favourites: PropTypes.array.isRequired,
  searchQuery: PropTypes.string
};

const mapStateToProps = state => ({
  favourites: state.beer.favourites,
  searchQuery: state.beer.searchQuery
});

export default connect(
  mapStateToProps,
  {}
)(Favourites);
